import Vue from "vue";

const ROOT_API = process.env.VUE_APP_ROOT_API;
const LOAD_PLOTS = ROOT_API + 'load_file/load_plots_xls.php';
const GET_PLOTS = ROOT_API + "get_site_data/get_plots.php";
const RECOUNT = ROOT_API + "get_site_data/recount.php";
const GET_SPECIES = ROOT_API + "get_site_data/get_species.php";
const GET_SPECIES_TAX = ROOT_API + "get_site_data/get_species_tax.php";
const GET_DAMAGE_REASONS =
  ROOT_API + "get_site_data/get_damage_reasons_by_species.php";
const GET_DAMAGE_SYMPTOMS =
  ROOT_API + "get_site_data/get_damage_symptoms_by_reason_and_state_cat.php";
const GET_MODEL_TREES = ROOT_API + "get_site_data/get_model_trees.php";

//const GET_VB = ROOT_API + "get_site_data/get_vb.php";
const GET_VB_DAMAGES = ROOT_API + "get_site_data/get_vb_damages.php";
const GET_VB_PCT = ROOT_API + "get_site_data/get_vb_pct.php";
const IS_FELLING = ROOT_API + "get_site_data/is_felling.php";

const GET_CIRCLE_COUNT = ROOT_API + "get_site_data/get_circle_count.php";
const GET_CIRCLE_R = ROOT_API + "get_site_data/get_circle_r.php";

const CHECK_S_PLOT = ROOT_API + "get_site_data/check_s_plot.php";
const CHECK_IS_LAYER_CORRECT =
  ROOT_API + "get_site_data/check_is_layer_correct.php";

const GET_MAIN_DAMAGE_REASON_LIST =
  ROOT_API + "get_site_data/get_main_damage_reason_list.php";
const GET_SELECTED_MAIN_DAMAGE_REASON_LIST =
  ROOT_API + "get_site_data/get_selected_main_damage_reason_list.php";
import processJSON from "@/lib/processJSON";
import requestToApi from "@/lib/requestToApi";
export default {
  namespaced: true,

  state: {
    plotList: [],
    treeList: {},
    modelTreeList: [],

    speciesList: [],

    speciesListTax: [],

    damageReasonList: [],
    damageSymptomList: [],

    landList: [],
    landDamageList: [],
    landTaxSpecies: [],

    vbList: [],
    vbDamageList: [],
    vbTaxSpecies: [],
    vbPct: null,

    wreckList: [],

    circleCount: null,
    circleR: [],

    mainDamageReasonList: [],
    selectedMainDamageReasonList: [],
  },

  getters: {
    recountIsOpen(state) {
      return state.plotList.length
        ? state.plotList[0].is_draft === "t"
          ? true
          : false
        : true;
    },
    modelTreesExist(state) {
      return state.modelTreeList.length
        ? state.modelTreeList[0].mt_exists === "t"
          ? true
          : false
        : false;
    },
    modelTreesAreOpen(state) {
      return state.modelTreeList.length
        ? state.modelTreeList[0].is_draft === "t"
          ? true
          : false
        : true;
    },
    bvRecountCheck(state, getters, rootState, rootGetters) {
      const check = state.vbList.map(e => e.state_cats.reduce((sum, item) =>+item.trees_proc+sum, 0)).every(element => element === 100);
      return check;
      },
  },

  mutations: {
    setMainDamageReasonList(state, payload) {
      state["mainDamageReasonList"] = payload;
    },
    setSelectedMainDamageReasonList(state, payload) {
      state["selectedMainDamageReasonList"] = payload;
    },

    setPlotList(state, payload) {
      state["plotList"] = payload;
    },

    setTreeList(state, payload) {
      state["treeList"] = payload;
    },

    setTreeListOfPlot(state, payload) {
      const plot_id = payload.plot_id;
      const res = payload.res;

      state.treeList[plot_id] = res;
    },

    reformTreeList(state) {
      for (const plot_id in state.treeList) {
        if (!state.plotList.find((plot) => plot.id === plot_id)) {
          delete state.treeList[plot_id];
        }
      }

      for (const plot of state.plotList) {
        if (!state.treeList[plot.id]) {
          Vue.set(state.treeList, plot.id, []);
        }
      }
    },

    setModelTreeList(state, payload) {
      state["modelTreeList"] = payload;
    },

    setSpeciesList(state, payload) {
      state["speciesList"] = payload;
    },

    setSpeciesListTax(state, payload) {
      state["speciesListTax"] = payload;
    },

    setDamageReasonList(state, payload) {
      state["damageReasonList"] = payload;
    },
    setDamageSymptomList(state, payload) {
      state["damageSymptomList"] = payload;
    },

    setVbList(state, payload) {
      state["vbList"] = payload;
    },
    setVbDamageList(state, payload) {
      state["vbDamageList"] = payload;
    },
    setVbPct(state, payload) {
      state["vbPct"] = payload;
    },

    setWreckList(state, payload) {
      state["wreckList"] = payload;
    },

    clearRecount(state, payload) {
      state["plotList"] = [];
      state["treeList"] = [];
      state["modelTreeList"] = [];

      state["vbList"] = [];
      state["vbDamageList"] = [];
      state["wreckList"] = [];

      state["circleCount"] = null;
      state["circleR"] = [];
    },

    clearDamageReasonList(state, payload) {
      state["damageReasonList"] = [];
    },
    clearDamageSymptomList(state, payload) {
      state["damageSymptomList"] = [];
    },

    setCircleCount(state, payload) {
      state.circleCount = payload;
    },
    setCircleR(state, payload) {
      state.circleR = payload;
    },
  },
  actions: {
    importExcelPlots(context, payload) {
      const { rootState, commit, dispatch } = context;
      const lpo_id = rootState.selectedLpo.lpo.lpo_id;
      let inputFile = payload.files[0]
      const form = new FormData();
      form.append('file', inputFile);
      form.append('lpo_id', lpo_id);
      fetch(LOAD_PLOTS, {
        credentials: 'include',
        method: 'post',
        body: form,
      })
      .then(res => res.json())
      .then(res => {
        if (res.result == 0) {
          dispatch("updatePlotList");
        } else {
          alert('Координаты не загружены');
        }
      })
      .catch(err => {
        throw err;
      })
      .finally(() => {
        payload.value = null;
      });
    },
    getMainDamageReasonList(context, payload) {
      const { rootState, commit } = context;

      const lpo = rootState.selectedLpo.lpo;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetch(GET_MAIN_DAMAGE_REASON_LIST, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setMainDamageReasonList", res);
        })
        .catch((err) => {
          throw err;
        });
    },

    getSelectedMainDamageReasonList(context, payload) {
      const { rootState, commit } = context;

      const lpo = rootState.selectedLpo.lpo;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetch(GET_SELECTED_MAIN_DAMAGE_REASON_LIST, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setSelectedMainDamageReasonList", res);
        })
        .catch((err) => {
          throw err;
        });
    },

    saveMainDamageReasons(context, payload) {
      const { rootState, state } = context;
      const { savingReasonList, mainReasonId } = payload;

      const lpo = rootState.selectedLpo.lpo;

      const reasonsForInsert = [];
      const reasonsForUpdate = [];
      const reasonsForDelete = [];

      const insert_section = [];
      const update_section = [];
      const delete_section = [];

      for (const savingReason of savingReasonList) {
        const finded = state.selectedMainDamageReasonList.find((reason) => {
          return reason.reason_id === savingReason.reason_id;
        });
        // если сохраняемый элемент найден в уже добавленных
        // то добавлять его повторно не надо
        if (finded) {
          reasonsForUpdate.push(finded);
        } else {
          reasonsForInsert.push(savingReason);
        }
      }

      for (const selectedReason of state.selectedMainDamageReasonList) {
        const finded = savingReasonList.find((reason) => {
          return reason.reason_id === selectedReason.reason_id;
        });
        // если уже сохраненная причина не найдена
        // в сохраняемом списке, значит ее надо удалить
        if (!finded) {
          reasonsForDelete.push(selectedReason);
        }
      }

      for (const reason of reasonsForInsert) {
        const temp = {
          tab_name: "data_lpo_main_damage_reasons",
          f_v: {
            parent_id: lpo.lpo_id,
            reason_id: reason.reason_id,
            is_main: reason.reason_id === mainReasonId,
          },
        };

        insert_section.push(temp);
      }

      for (const reason of reasonsForUpdate) {
        const temp = {
          tab_name: "data_lpo_main_damage_reasons",
          f_v: {
            id: reason.id,
            reason_id: reason.reason_id,
            is_main: reason.reason_id === mainReasonId,
          },
        };

        update_section.push(temp);
      }

      for (const reason of reasonsForDelete) {
        const temp = {
          tab_name: "data_lpo_main_damage_reasons",
          id: reason.id,
        };

        delete_section.push(temp);
      }

      const json_obj = [
        {
          i: {
            tab: insert_section,
          },
        },
        {
          u: update_section,
        },
        {
          d: delete_section,
        },
      ];

      const json_str = JSON.stringify(json_obj);
      return processJSON(json_str);
    },

    getRecount(context) {
      const { rootState, commit, dispatch } = context;

      commit("clearRecount");

      const lpo_id = rootState.selectedLpo.lpo.lpo_id;

      if (rootState.selectedLpo.lpo.inspection_type_id === "5") {
        dispatch("getPlotList", lpo_id);
        dispatch("getVbList");
        dispatch("getVbPct");
        dispatch("getSpeciesListTax");
      } else if (rootState.selectedLpo.lpo.inspection_type_id === "7") {
        dispatch("getPlotList", lpo_id);
        dispatch("getVbList");
        dispatch("getVbPct");
        dispatch("getSpeciesListTax");
      } else if (rootState.selectedLpo.lpo.inspection_type_id === "6") {
        dispatch("getSpeciesList");
      } else if (rootState.selectedLpo.lpo.inspection_type_id === "9") {
        dispatch("getSpeciesListTax");
      } else {
        dispatch("getPlotList", lpo_id).then((res) => {
          if (res.length) {
            dispatch("getTreeList", res);
            dispatch("getModelTreeList", lpo_id);
          }
          if (rootState.selectedLpo.lpo.inspection_type_id === "4") {
            dispatch("getCircleCount");
            dispatch("getCircleR");
          }
        });
      }
    },

    updateRecount(context) {
      const { rootState, dispatch } = context;

      const lpo_id = rootState.selectedLpo.lpo.lpo_id;

      return dispatch("getRecount", lpo_id);
    },

    removeRecount(context) {
      const { dispatch } = context;

      return dispatch("removeAllPlots").then((res) => {
        return dispatch("removeModelTreeList");
      });
    },

    checkSPlot(context) {
      const { rootState } = context;

      const lpo = rootState.selectedLpo.lpo;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetch(CHECK_S_PLOT, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },

    getCircleCount(context) {
      const { rootState, commit } = context;

      const lpo = rootState.selectedLpo.lpo;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetch(GET_CIRCLE_COUNT, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setCircleCount", res.czl_get_circle_count);
        })
        .catch((err) => {
          throw err;
        });
    },
    getCircleR(context) {
      const { rootState, commit } = context;

      const lpo = rootState.selectedLpo.lpo;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetch(GET_CIRCLE_R, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit(
            "setCircleR",
            res.map((item) => item.r)
          );
        })
        .catch((err) => {
          throw err;
        });
    },

    getPlotList(context) {
      const { rootState, commit, dispatch } = context;

      const lpo = rootState.selectedLpo.lpo;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetch(GET_PLOTS, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          if (
            (
              lpo.inspection_type_id === "10" ||
              lpo.inspection_type_id === "3" ||
              lpo.inspection_type_id === "5" ||
              lpo.inspection_type_id === "7"
              
            ) &&
            !res.length
          ) {
            const temp = {
              lpo: lpo,
              width: null,
              pointList: [],
            };
            
            return dispatch("addPlot", temp)
              .then((res) => {
                return dispatch("getPlotList");
              })
              .then((res) => {
                commit("setPlotList", res);
                return res;
              });
          } else {
            commit("setPlotList", res);
            return res;
          }
        })
        .catch((err) => {
          throw err;
        });
    },

    updatePlotList(context, payload) {
      const { commit, dispatch } = context;

      const lpo_id = payload;

      return dispatch("getPlotList", lpo_id).then((res) => {
        commit("reformTreeList");
      });
    },

    addPlot(context, payload) {
      const { state } = context;

      const lpo = payload.lpo;
      const width = payload.width;
      const lengthManual = payload.lengthManual;
      const pointList = payload.pointList;
      let s = payload.s;
      if (s === "") {
        s = null;
      }

      const tabPoints = [];
      for (let i = 0; i < pointList.length; ++i) {
        const point = pointList[i];

        const temp = {
          tab_name: "data_lpo_plot_points",
          f_v: {
            point_num: i + 1,
            lat: point.lat,
            lon: point.lon,
          },
        };
        tabPoints.push(temp);
      }

      const json_obj = [
        {
          i: {
            tab: [
              {
                tab_name: "data_lpo_plot",
                f_v: {
                  parent_id: lpo.lpo_id,
                  num: state.plotList.length + 1,
                  radius_width: ["1", "4"].includes(lpo.inspection_type_id) ? width : null,
                  length_manual: lpo.inspection_type_id === "1" ? lengthManual : null,
                  //radius_width: width,
                  s_manual: s,
                  slope_angle_id:
                  lpo.inspection_type_id === "2" ? width?.id : null,
                    //lpo.inspection_type_id === "2" ? width : null,
                },
                tab: tabPoints,
              },
            ],
          },
        },
      ];
      const json_str = JSON.stringify(json_obj);
      return processJSON(json_str);
    },

    editPlotStrip(context, payload) {
      const plot = payload.plot;
      const width = payload.width;
      const lengthManual = payload.lengthManual;
      const pointList = payload.pointList;

      let s = payload.s;
      if (s === "") {
        s = null;
      }

      const insertSection = [];
      for (let i = 0; i < pointList.length; ++i) {
        const point = pointList[i];

        const temp = {
          tab_name: "data_lpo_plot_points",
          f_v: {
            parent_id: plot.id,
            point_num: i + 1,
            lat: point.lat,
            lon: point.lon,
          },
        };
        insertSection.push(temp);
      }

      const deleteSection = [];
      for (const point of plot.points) {
        const temp = {
          tab_name: "data_lpo_plot_points",
          id: point.id,
        };
        deleteSection.push(temp);
      }

      const json_obj = [
        {
          i: {
            tab: insertSection,
          },
        },
        {
          u: [
            {
              tab_name: "data_lpo_plot",
              f_v: {
                id: plot.id,
                radius_width: width,
                length_manual: lengthManual,
                s_manual: s,
              },
            },
          ],
        },
        {
          d: deleteSection,
        },
      ];

      const json_str = JSON.stringify(json_obj);

      return processJSON(json_str);
    },

    editPlotCircle(context, payload) {
      const lpo = payload.lpo;
      const plot = payload.plot;
      const width = payload.width;
      const pointList = payload.pointList;

      const insertSection = [];
      for (let i = 0; i < pointList.length; ++i) {
        const point = pointList[i];

        const temp = {
          tab_name: "data_lpo_plot_points",
          f_v: {
            parent_id: plot.id,
            point_num: i + 1,
            lat: point.lat,
            lon: point.lon,
          },
        };
        insertSection.push(temp);
      }

      const deleteSection = [];
      for (const point of plot.points) {
        const temp = {
          tab_name: "data_lpo_plot_points",
          id: point.id,
        };
        deleteSection.push(temp);
      }

      const json_obj_update = [
        {
          i: {
            tab: insertSection,
          },
        },
        {
          u: [
            {
              tab_name: "data_lpo_plot",
              f_v: {
                id: plot.id,
                radius_width: lpo.inspection_type_id === "4" ? width : null,
                slope_angle_id:
                  lpo.inspection_type_id === "2" ? width?.id : null,
              },
            },
          ],
        },
      ];

      const json_obj_delete = [
        {
          d: deleteSection,
        },
      ];

      const json_str_update = JSON.stringify(json_obj_update);
      const json_str_delete = JSON.stringify(json_obj_delete);

      return processJSON(json_str_delete).then((res) => {
        return processJSON(json_str_update);
      });
    },

    removePlot(context, payload) {
      const { state } = context;

      const plot = payload;

      const updateSection = [];
      for (let i = +plot.num; i < state.plotList.length; ++i) {
        const updatedPlot = state.plotList[i];

        const temp = {
          tab_name: "data_lpo_plot",
          f_v: {
            id: updatedPlot.id,
            num: i,
          },
        };

        updateSection.push(temp);
      }

      const json_renum_obj = [
        {
          u: updateSection,
        },
      ];

      const json_renum_str = JSON.stringify(json_renum_obj);

      const json_obj = [
        {
          d: [
            {
              tab_name: "data_lpo_plot",
              id: plot.id,
            },
          ],
        },
      ];

      const json_str = JSON.stringify(json_obj);

      return processJSON(json_str).then((res) => {
        return processJSON(json_renum_str);
      });
    },
    removeAllPlots(context) {
      const { state } = context;

      const deleteSection = [];
      for (const plot of state.plotList) {
        const temp = {
          tab_name: "data_lpo_plot",
          id: plot.id,
        };
        deleteSection.push(temp);
      }

      const json_obj = [
        {
          d: deleteSection,
        },
      ];
      const json_str = JSON.stringify(json_obj);
      return processJSON(json_str);
    },

    /* TREE LIST */
    async getTreeList(context, payload) {
      const { rootState, commit, dispatch } = context;
      const lpo_id = rootState.selectedLpo.lpo.lpo_id;
      const plotList = payload ? payload: [];
      let treeList = {};

      //for (const plot of plotList) {
        const form = new FormData();
        form.append("lpo_id", lpo_id);
        let params = {
          url: RECOUNT,
          params: {lpo_id: lpo_id}
        }
        const res = await requestToApi(params);
        plotList.forEach(plot => {
          treeList[plot.id] = res.filter(item => item.parent_id == plot.id)
        })
      //   await fetch(RECOUNT, {
      //     credentials: "include",
      //     method: "post",
      //     body: form,
      //   })
      //     .then((res) => res.json())
      //     .then((res) => {

      //       plotList.forEach(plot => {
      //         treeList[plot.id] = res.filter(item => item.parent_id == plot.id)
      //       }) 
        
      //     })
      //     .catch((err) => {
      //       throw err;
      //     });
      // //}
      dispatch("selectedLpo/getFreq", null, { root: true });
      commit("setTreeList", treeList);
    },
    async old_getTreeList(context, payload) {
      const { rootState, commit, dispatch } = context;
      const lpo_id = rootState.selectedLpo.lpo.lpo_id;
      let treeList = {};

      //for (const plot of plotList) {
        const form = new FormData();
        form.append("lpo_id", lpo_id);

        await fetch(GET_TREE_LIST, {
          credentials: "include",
          method: "post",
          body: form,
        })
          .then((res) => res.json())
          .then((res) => {
            res.forEach(element => {
              if (!(element.parent_id in treeList)) {
                treeList[element.parent_id] = [];
              }
              treeList[element.parent_id].push(element)
            });
            //treeList[plot.id] = res;
            //dispatch("selectedLpo/getFreq", null, { root: true });
          })
          .catch((err) => {
            throw err;
          });
      //}
      dispatch("selectedLpo/getFreq", null, { root: true });
      commit("setTreeList", treeList);
    },


    getSpeciesList(context) {
      const { rootState, commit } = context;

      const lpo_id = rootState.selectedLpo.lpo.lpo_id;

      const form = new FormData();
      form.append("lpo_id", lpo_id);

      fetch(GET_SPECIES, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setSpeciesList", res);
        })
        .catch((err) => console.log(err));
    },

    updateSpeciesList(context) {
      const { dispatch } = context;
      return dispatch("getSpeciesList");
    },

    getSpeciesListTax(context) {
      const { rootState, commit } = context;

      const lpo_id = rootState.selectedLpo.lpo.lpo_id;

      const form = new FormData();
      form.append("lpo_id", lpo_id);

      fetch(GET_SPECIES_TAX, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setSpeciesListTax", res);
        })
        .catch((err) => console.log(err));
    },

    updateSpeciesListTax(context, payload) {
      const { dispatch } = context;

      return dispatch("getSpeciesListTax");
    },

    getDamageReasonList(context, payload) {
      const { commit } = context;

      const species_id = payload;

      const form = new FormData();
      form.append("species_id", species_id);

      fetch(GET_DAMAGE_REASONS, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setDamageReasonList", res);
        })
        .catch((err) => console.log(err));
    },
    getDamageSymptomList(context, payload) {
      const { commit } = context;

      const state_cat_id = payload.state_cat_id;
      const reason_id = payload.reason_id;

      const form = new FormData();
      form.append("state_cat_id", state_cat_id);
      form.append("reason_id", reason_id);

      fetch(GET_DAMAGE_SYMPTOMS, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setDamageSymptomList", res);
        })
        .catch((err) => console.log(err));
    },

    addTree(context, payload) {
      const { state } = context;

      const plot_id = payload.plot_id;
      const count = payload.count;
      const tree = payload.tree;
      const damages = tree.damages;
      const tabDamages = [];
      for (const damage of damages) {
        const temp = {
          tab_name: "data_lpo_inventory_damages",
          f_v: {
            reason_id: damage.reason_id,
            symptom_id: damage.symptom_id,
          },
        };
        tabDamages.push(temp);
      }

      let num = state.treeList[plot_id].length + 1;

      const tab = [];
      for (let i = 0; i < count; ++i) {
        const temp = {
          tab_name: "data_lpo_inventory",
          f_v: {
            parent_id: plot_id,
            tree_num: num++,
            layer: tree.layer,
            gen: tree.gen,
            species_id: tree.species.id,
            d: tree.d,
            s_05: tree.s_05,
            state_cat_id: tree.state_cat.id,
            is_liquid: tree.is_liquid,
            nonliquid_reason_id: tree.nonliquid_reason
              ? tree.nonliquid_reason.id
              : null,
          },
          tab: tabDamages,
        };
        tab.push(temp);
      }

      const json_obj = [
        {
          i: {
            tab: tab,
          },
        },
      ];

      const json_str = JSON.stringify(json_obj);

      return processJSON(json_str);
    },
    editTree(context, payload) {
      const selectedTreeList = payload.selectedTreeList;
      const editedTree = payload.editedTree;

      const deleteSection = [];
      for (const tree of selectedTreeList) {
        for (const damage of tree.damages) {
          const temp = {
            tab_name: "data_lpo_inventory_damages",
            id: damage.id,
          };
          deleteSection.push(temp);
        }
      }

      const insertSection = [];
      for (const tree of selectedTreeList) {
        for (const damage of editedTree.damages) {
          const temp = {
            tab_name: "data_lpo_inventory_damages",
            f_v: {
              parent_id: tree.id,
              reason_id: damage.reason_id,
              symptom_id: damage.symptom_id,
            },
          };
          insertSection.push(temp);
        }
      }

      const updateSection = [];
      for (const tree of selectedTreeList) {
        const temp = {
          tab_name: "data_lpo_inventory",
          f_v: {
            id: tree.id,
            layer: editedTree.layer,
            gen: editedTree.gen,
            species_id: editedTree.species.id,
            d: editedTree.d,
            s_05: editedTree.s_05,
            state_cat_id: editedTree.state_cat.id,
            is_liquid: editedTree.is_liquid,
            nonliquid_reason_id: editedTree.nonliquid_reason
              ? editedTree.nonliquid_reason.id
              : null,
          },
        };
        updateSection.push(temp);
      }

      const json_obj = [
        {
          i: {
            tab: insertSection,
          },
        },
        {
          u: updateSection,
        },
        {
          d: deleteSection,
        },
      ];

      const json_str = JSON.stringify(json_obj);
      return processJSON(json_str);
    },
    removeTree(context, payload) {
      const { state } = context;

      const plot_id = payload.plot_id;
      const tree = payload.tree;

      const updateSection = [];
      for (let i = +tree.tree_num; i < state.treeList[plot_id].length; ++i) {
        const updatedTree = state.treeList[plot_id][i];

        const temp = {
          tab_name: "data_lpo_inventory",
          f_v: {
            id: updatedTree.id,
            tree_num: i,
          },
        };

        updateSection.push(temp);
      }

      const json_renum_obj = [
        {
          u: updateSection,
        },
      ];

      const json_renum_str = JSON.stringify(json_renum_obj);
      const json_obj = [
        {
          d: [
            {
              tab_name: "data_lpo_inventory",
              id: tree.id,
            },
          ],
        },
      ];

      const json_str = JSON.stringify(json_obj);

      return processJSON(json_str).then((res) => {
        return processJSON(json_renum_str);
      });
    },

    removeSelectedTrees(context, payload) {
      const { state } = context;

      const plot_id = payload.plot_id;
      const selectedTrees = payload.selectedTrees;

      const remainTrees = state.treeList[plot_id].filter((tree) => {
        return !selectedTrees.find((s_tree) => s_tree.id === tree.id);
      });

      const updateSection = [];
      for (let i = 0; i < remainTrees.length; ++i) {
        const updatedTree = remainTrees[i];

        const temp = {
          tab_name: "data_lpo_inventory",
          f_v: {
            id: updatedTree.id,
            tree_num: i + 1,
          },
        };

        updateSection.push(temp);
      }

      const json_renum_obj = [
        {
          u: updateSection,
        },
      ];

      const json_renum_str = JSON.stringify(json_renum_obj);

      const deleteSection = [];
      for (const tree of selectedTrees) {
        const temp = {
          tab_name: "data_lpo_inventory",
          id: tree.id,
        };
        deleteSection.push(temp);
      }

      const json_obj = [
        {
          d: deleteSection,
        },
      ];

      const json_str = JSON.stringify(json_obj);

      return processJSON(json_str).then((res) => {
        return processJSON(json_renum_str);
      });
    },

    toggleRecount(context, payload) {
      const { state, commit, dispatch } = context;

      const lpo_id = payload;

      const value = state.plotList.length ? state.plotList[0].is_draft === "t" ? false: true: true;

      const updateSection = [];
      for (const plot of state.plotList) {
        const temp = {
          tab_name: "data_lpo_plot",
          f_v: {
            id: plot.id,
            is_draft: value,
          },
        };
        updateSection.push(temp);
      }

      const json_obj = [
        {
          u: updateSection,
        },
      ];

      const json_str = JSON.stringify(json_obj);

      return processJSON(json_str).then((res) => {
        if (value) {
          // если открываем перечет
          if (
            state.modelTreeList.length &&
            state.modelTreeList[0].mt_exists === "t"
          ) {
            dispatch("removeModelTreeList");
          }
          commit("setModelTreeList", []);
        } else {
          // если закрываем
          dispatch("getModelTreeList", lpo_id);
        }

        dispatch("selectedLpo/getFreq", null, { root: true });
      });
    },
    checkIsLayerCorrect(context, payload) {
      const { rootState } = context;

      const lpo = rootState.selectedLpo.lpo;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetch(CHECK_IS_LAYER_CORRECT, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          return res[0];
        })
        .catch((err) => {
          throw err;
        });
    },

    /* MODEL TREES */
    getModelTreeList(context, payload) {
      const { commit } = context;

      const lpo_id = payload;

      const form = new FormData();
      form.append("lpo_id", lpo_id);

      return fetch(GET_MODEL_TREES, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setModelTreeList", res);
        })
        .catch((err) => {
          throw err;
        });
    },

    updateModelTreeList(context) {
      const { rootState, dispatch } = context;

      const lpo = rootState.selectedLpo.lpo;

      return dispatch("getModelTreeList", lpo.lpo_id);
    },

    saveModelTreeList(context, payload) {
      const { rootState, getters } = context;
      const modelTreesExist = getters.modelTreesExist;

      const lpo = rootState.selectedLpo.lpo;

      const modelTreeList = payload;

      let json_obj = null;
      if (modelTreesExist) {
        const updateSection = [];
        for (const tree of modelTreeList) {
          const temp = {
            tab_name: "data_lpo_model_trees",
            f_v: {
              id: tree.id,
              plot_num: tree.plot_num,
              species_id: tree.species_id,
              d: tree.d,
              height: tree.height,
              age: tree.age,
              layer: tree.layer,
              gen: tree.gen,
              is_draft: tree.is_draft,
            },
          };
          updateSection.push(temp);
        }

        json_obj = [
          {
            u: updateSection,
          },
        ];
      } else {
        const tab = [];
        for (const tree of modelTreeList) {
          const temp = {
            tab_name: "data_lpo_model_trees",
            f_v: {
              parent_id: lpo.lpo_id,
              plot_num: tree.plot_num,
              species_id: tree.species_id,
              d: tree.d,
              height: tree.height,
              age: tree.age,
              layer: tree.layer,
              gen: tree.gen,
              is_draft: tree.is_draft,
            },
          };
          tab.push(temp);
        }

        json_obj = [
          {
            i: {
              tab: tab,
            },
          },
        ];
      }

      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      return processJSON(json_str);
    },

    removeModelTreeList(context) {
      const { state } = context;

      const deleteSection = [];
      for (const tree of state.modelTreeList) {
        const temp = {
          tab_name: "data_lpo_model_trees",
          id: tree.id,
        };
        deleteSection.push(temp);
      }

      const json_obj = [
        {
          d: deleteSection,
        },
      ];
      const json_str = JSON.stringify(json_obj);
      return processJSON(json_str);
    },

    toggleModelTrees(context, payload) {
      const { state, rootState, dispatch } = context;

      const value = state.modelTreeList.length
        ? state.modelTreeList[0].is_draft === "t"
          ? false
          : true
        : true;

      const updateSection = [];
      for (const tree of state.modelTreeList) {
        const temp = {
          tab_name: "data_lpo_model_trees",
          f_v: {
            id: tree.id,
            is_draft: value,
          },
        };
        updateSection.push(temp);
      }

      const json_obj = [
        {
          u: updateSection,
        },
      ];

      const json_str = JSON.stringify(json_obj);

      return processJSON(json_str).then((res) => {
        dispatch("selectedLpo/getCriticalDensityParams", null, { root: true });
        dispatch("selectedLpo/getTaxComparison", null, { root: true });
        dispatch("selectedLpo/getFreq", null, { root: true });
      });
    },

    /* VISUAL */
    async setRemoteListRecount(context, payload) {
      const insertSection = [];
      const updateSection = [];
      for (const item of payload) {
        if (!item.id) {
          const temp = {
            tab_name: "data_lpo_remote_dzz",
            f_v: {
              parent_id: item.lpo_id,
              condition_id: item.condition_id,
              damage_id: item.damage_id,
              image_date: item.image_date == '' ? null: item.image_date
            },
          };
          insertSection.push(temp);
        } else {
          const temp = {
            tab_name: "data_lpo_remote_dzz",
            f_v: {
              id: item.id,
              condition_id: item.condition_id,
              damage_id: item.damage_id,
              image_date: item.image_date == '' ? null: item.image_date
            },
          };
          updateSection.push(temp);
        }
      }
      const json_obj = [
        {
          i: {
            tab: insertSection,
          },
        },
        {
          u: updateSection,
        },
        // {
        //   d: deleteSection,
        // },
      ];

      const json_str = JSON.stringify(json_obj);
      const result = await processJSON(json_str);
      return result;
    },
    async setRemoteImageInfo(context, payload) {
      const { rootState, commit, dispatch } = context;
      const insertSection = [];
      const updateSection = [];
      for(let key in payload) {
        if (payload[key] == '') {
          payload[key] = null;
        }
      }
      if (!payload.id) {
        const parent_id = rootState.selectedLpo.lpo.lease_id;
        const temp = {
          tab_name: "data_lpo_remote_image_info",
          f_v: Object.assign({parent_id: parent_id}, payload),
        };
        insertSection.push(temp);
      } else {
        const temp = {
          tab_name: "data_lpo_remote_image_info",
          f_v: payload,
        };
        updateSection.push(temp);
      }
      const json_obj = [
        {
          i: {
            tab: insertSection,
          },
        },
        {
          u: updateSection,
        },
        // {
        //   d: deleteSection,
        // },
      ];

      const json_str = JSON.stringify(json_obj);
      const result = await processJSON(json_str);
      return result;
    },
    async getVbList(context, payload) {
      const { rootState, commit, dispatch } = context;

      const lpo = rootState.selectedLpo.lpo;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);
      let params = {
        url: RECOUNT,
        params: {lpo_id: lpo.lpo_id}
      }
      const res = await requestToApi(params);
      commit("setVbList", res);
      dispatch("getVbPct");
      dispatch("selectedLpo/getFreq", null, { root: true });
      return res;
      // return fetch(RECOUNT, {
      //   credentials: "include",
      //   method: "post",
      //   body: form,
      // })
      //   .then((res) => res.json())
      //   .then((res) => {
      //     commit("setVbList", res);
      //     dispatch("getVbPct");
      //     dispatch("selectedLpo/getFreq", null, { root: true });
      //     return res;
      //   })
      //   .catch((err) => {
      //     throw err;
      //   });
    },
    updateVbList(context, payload) {
      const { dispatch } = context;
      return dispatch("getVbList");
    },
    removeVbList(context, payload) {
      const { state, rootState, commit, dispatch } = context;

      console.log("state: ", state.vbList.length === 1 && !state.vbList[0].id);

      if (state.vbList.length === 1 && !state.vbList[0].id) {
        return;
      }

      const lpo = rootState.selectedLpo.lpo;

      const deleteSection = [];

      for (const item of state.vbList) {
        const temp = {
          tab_name: "data_lpo_land",
          id: item.id,
        };
        deleteSection.push(temp);
      }

      const json_obj = [
        {
          d: deleteSection,
        },
      ];

      const json_str = JSON.stringify(json_obj);
      return processJSON(json_str);
    },

    getVbDamageList(context, payload) {
      const { rootState, commit, dispatch } = context;

      const lpo = rootState.selectedLpo.lpo;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetch(GET_VB_DAMAGES, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setVbDamageList", res);
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
    updateVbDamageList(context, payload) {
      const { dispatch } = context;
      return dispatch("getVbDamageList");
    },

    getVbPct(context, payload) {
      const { rootState, commit, dispatch } = context;

      const lpo = rootState.selectedLpo.lpo;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetch(GET_VB_PCT, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setVbPct", res.czl_get_vb_pct);
        })
        .catch((err) => {
          throw err;
        });
    },
    updateVbPct(context, payload) {
      const { dispatch } = context;
      return dispatch("getVbPct");
    },
    saveVb(context, payload) {
      const { state } = context;

      const species = payload.species;
      const distribution = payload.values;

      const speciesFromDB = state.vbList.find((item) => {
        return (
          item.info.species_id === species.species_id &&
          item.info.layer === species.layer &&
          item.info.gen === species.gen
        );
      });
      

      const insertSection = [];
      const updateSection = [];
      const deleteSection = [];
      for (const stateCat of speciesFromDB.state_cats) {
        const finded = distribution.find(d => d.state_cat_id === stateCat.state_cat_id);
        if (finded.common !== "0" && finded.common !== "") {
          continue;
        }
        const temp = {
          tab_name: "data_lpo_land",
          id: stateCat.id,
        };
        deleteSection.push(temp);
      }

      for (const stateCat of distribution) {
        if (stateCat.common === "0") {
          continue;
        }

        const finded = speciesFromDB.state_cats.find(d => d.state_cat_id === stateCat.state_cat_id
        );

        let is5Cat = false;
        if (
          stateCat.state_cat_id === "5" ||
          stateCat.state_cat_id === "6" ||
          stateCat.state_cat_id === "7" ||
          stateCat.state_cat_id === "8" ||
          stateCat.state_cat_id === "9" ||
          stateCat.state_cat_id === "10"
        ) {
          is5Cat = true;
        }

        if (!finded) {
          // insert
          const temp = {
            tab_name: "data_lpo_land",
            f_v: {
              parent_id: state.plotList[0].id,
              species_id: species.species_id,
              layer: species.layer,
              gen: species.gen,
              state_cat_id: stateCat.state_cat_id,
              trees_proc: +stateCat.common,
              felling_proc: is5Cat ? +stateCat.common : +stateCat.felling,
            },
          };

          // автоматическое добавление повреждения для БВ
          if (
            stateCat.state_cat_id === "6" ||
            stateCat.state_cat_id === "7" ||
            stateCat.state_cat_id === "9" ||
            stateCat.state_cat_id === "10"
          ) {
            const sc = stateCat.state_cat_id;

            let reason_id = 0;
            let symptom_id = 0;
            let symptom_proc = stateCat.common;

            if (sc === "6") {
              // свежий ветровал
              reason_id = "881";
              symptom_id = "205";
            } else if (sc === "7") {
              // свежий бурелом
              reason_id = "882";
              symptom_id = "217";
            } else if (sc === "9") {
              // старый ветровал
              reason_id = "821";
              symptom_id = "206";
            } else if (sc === "10") {
              // старый бурелом
              reason_id = "822";
              symptom_id = "218";
            }

            const damageTab = [
              {
                tab_name: "data_lpo_land_damages",
                f_v: {
                  reason_id: reason_id,
                  symptom_id: symptom_id,
                  symptom_proc: symptom_proc,
                },
              },
            ];

            temp.tab = damageTab;
            temp.f_v.felling_proc = symptom_proc;
          }

          insertSection.push(temp);
        } else {
          // update

          if (
            finded.trees_proc === stateCat.common &&
            finded.felling_proc === stateCat.felling
          ) {
            continue;
          }

          const temp = {
            tab_name: "data_lpo_land",
            f_v: {
              id: finded.id,
              trees_proc: +stateCat.common,
              felling_proc: is5Cat ? +stateCat.common : +stateCat.felling,
            },
          };
          updateSection.push(temp);
        }
      }

      const json_obj = [
        {
          i: {
            tab: insertSection,
          },
        },
        {
          u: updateSection,
        },
        {
          d: deleteSection,
        },
      ];
      const json_str = JSON.stringify(json_obj);
      //console.log(json_str)
      return processJSON(json_str);
    },

    saveVbDamage(context, payload) {
      const { dispatch } = context;

      const damage = payload;

      //console.log(JSON.stringify(damage, null, 2));

      const json_obj = [
        {
          i: {
            tab: [
              {
                tab_name: "data_lpo_land_damages",
                f_v: {
                  parent_id: damage.state_cat.id,
                  reason_id: damage.reason.id,
                  symptom_id: damage.symptom.id,
                  symptom_proc: damage.symptom_proc,
                },
              },
            ],
          },
        },
      ];
      const json_str = JSON.stringify(json_obj);

      return processJSON(json_str).then((res) => {
        return dispatch("isFelling", damage);
      });
    },

    removeVbDamage(context, payload) {
      const damage = payload;

      //console.log(damage);

      const json_obj = [
        {
          d: [
            {
              tab_name: "data_lpo_land_damages",
              id: damage.id,
            },
          ],
        },
      ];
      const json_str = JSON.stringify(json_obj);
      return processJSON(json_str);
    },

    editVbDamageProc(context, payload) {
      const { damage, newProc } = payload;
      const json_obj = [
        {
          u: [
            {
              tab_name: "data_lpo_land_damages",
              f_v: {
                id: damage.id,
                symptom_proc: newProc,
              },
            },
          ],
        },
      ];

      const json_str = JSON.stringify(json_obj);
      return processJSON(json_str);
    },

    isFelling(context, payload) {
      const { rootState } = context;

      const lpo = rootState.selectedLpo.lpo;
      const damage = payload;

      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);
      form.append("species_id", damage.species.species_id);
      form.append("reason_id", damage.reason.id);
      form.append("symptom_id", damage.symptom.id);
      form.append("state_cat_id", damage.state_cat.state_cat_id);

      return fetch(IS_FELLING, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          return res === "t" ? true : false;
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
